var WeeklyReportZIndex = {
    TABLE_HEADER: 11,
    STUCK_OVERLAY: 12,
    STUCK_STUDENTS: 13,
    BACK_TO_CURRENT_WEEK: 12,
};
var StickyElementSize = {
    TABLE_HEADER: 67,
    FILTER_ROW: 57,
    PAST_WEEK_NOTICE: 40,
};
export { WeeklyReportZIndex, StickyElementSize };
